import { useEffect, useState } from "react";

const KEY = "ftm_cookie_consent_v1";
const DEFAULT = { necessary: true, media: false, analytics: false, decided: false };
const listeners = new Set();

const read = () => {
    try {
        const raw = localStorage.getItem(KEY);
        return raw ? { ...DEFAULT, ...JSON.parse(raw), decided: true } : DEFAULT;
    } catch {
        return DEFAULT;
    }
};

let state = read();
let panelOpen = false;

const emit = () => listeners.forEach((fn) => fn({ consent: state, panelOpen }));

export const saveConsent = (partial) => {
    state = { ...DEFAULT, ...state, ...partial, necessary: true, decided: true };
    localStorage.setItem(KEY, JSON.stringify({ media: state.media, analytics: state.analytics }));
    panelOpen = false;
    emit();
};

export const acceptAll = () => saveConsent({ media: true, analytics: true });
export const rejectAll = () => saveConsent({ media: false, analytics: false });
export const openCookiePreferences = () => {
    panelOpen = true;
    emit();
};
export const closeCookiePreferences = () => {
    panelOpen = false;
    emit();
};

export const useConsent = () => {
    const [snap, setSnap] = useState({ consent: state, panelOpen });
    useEffect(() => {
        listeners.add(setSnap);
        return () => listeners.delete(setSnap);
    }, []);
    return snap;
};
